module.exports = __webpack_public_path__ + "img/ueber-uns.bfc7e26a.jpg";